export const supabaseCreds = {
  supabaseUrl: (process.env as any).NEXT_PUBLIC_SUPABASE_URL,
  supabaseKey: (process.env as any).SUPABASE_SR_KEY,
  supabaseAnonKey: (process.env as any).NEXT_PUBLIC_SUPABASE_ANON_KEY,
};
